function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
/**
 * The VisibilitySensor component provides a way to let components know when they are
 * on screen and visible or not.
 *
 * ## Dependencies
 * - [IntersectionObserver](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserver)
 *
 * ## TODO
 * - [ ] Add `onVisibilityChange` callback prop?
 * - [ ] Support all IntersectionObserver parameters
 *  - threshold - array of values to call callback when surpassed
 *  - root - root element to calculate intersections with
 *  - rootMargin - margin to affect intersection calculations
 *
 * ## Related Components
 * - [Media](../Media/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <VisibilitySensor
 *   oneShot
 *   intersectionThreshold={0.1}
 *   element={myRef}
 * >
 *   {(isVisible) => (
 *      <div ref={myRef} style={{
 *         width: '100px',
 *         height: '100px',
 *         backgroundColor: isVisible ? 'green' : 'red',
 *       }} />
 *   )}
 * </VisibilitySensor>
 * ```
 *
 * ## Props
 */

var VisibilitySensor = /*#__PURE__*/function (_PureComponent) {
  _inherits(VisibilitySensor, _PureComponent);

  var _super = _createSuper(VisibilitySensor);

  function VisibilitySensor(props) {
    var _this;

    _classCallCheck(this, VisibilitySensor);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isVisible: false
    });

    _this._node = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(VisibilitySensor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          intersectionThreshold = _this$props.intersectionThreshold,
          oneShot = _this$props.oneShot,
          element = _this$props.element;

      if (!IntersectionObserver) {
        throw new Error("IntersectionObserver API not present\n      but is required. Try adding a polyfill for this functionality");
      }

      this.intersectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio <= intersectionThreshold) {
            _this2.setState({
              isVisible: false
            });

            return;
          }

          _this2.setState({
            isVisible: true
          });

          if (_this2.intersectionObserver && oneShot) {
            _this2.intersectionObserver.disconnect();

            _this2.intersectionObserver = null;
          }
        });
      }, {
        threshold: [intersectionThreshold]
      });
      var elementToObserve = element ? element.current : this._node.current;

      if (!elementToObserve) {
        throw new Error('VisibilitySensor: Element not provided');
      }

      this.intersectionObserver.observe(elementToObserve);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.intersectionObserver) return;
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          className = _this$props2.className,
          element = _this$props2.element;
      var isChildFunction = typeof children === 'function';

      if (!element) {
        return /*#__PURE__*/React.createElement("div", {
          ref: this._node,
          className: className
        }, isChildFunction && children(this.state));
      }

      return /*#__PURE__*/React.createElement(Fragment, null, isChildFunction && children(this.state));
    }
  }]);

  return VisibilitySensor;
}(PureComponent);

VisibilitySensor.defaultProps = {
  intersectionThreshold: 0.1,
  oneShot: false,
  children: null,
  className: '',
  element: null
};
VisibilitySensor.propTypes = {
  /**
   * Value at which to consider the UI as visible or not
   */
  intersectionThreshold: PropTypes.number,

  /**
   * Whether to detect visibility once. When this is set only the first
   *
   */
  oneShot: PropTypes.bool,

  /**
   * Render prop to receive visibility state changes
   */
  children: PropTypes.func,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * Element allows passing in a forwarded ref to avoid having  an unnecessary wrapping
   * div
   */
  element: PropTypes.shape({
    current: PropTypes.node
  })
};
export default VisibilitySensor;